import React, { useEffect, useState, useRef } from 'react'
import cn from 'classnames'

import styles from './styles.module.scss'

const PlaceMarker = ({place, isHighlighted, isSelected, onClick}) => {
  const [active, setActive] = useState(false)

  const timeoutRef = useRef()

  useEffect(() => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current)
    }
    timeoutRef.current = setTimeout(() => {
      setActive(isHighlighted)
    }, 0)
  }, [isHighlighted])

  return (
    <div
      onClick={() => onClick(place)}
      className={cn(styles.marker, {[styles.selected]: isSelected})}
      style={{ zIndex: isHighlighted ? 2 : 1, boxShadow: active ? `0px 3px 6px 0px ${place.color}` : null}} >
      <div className={cn(styles.placeIcon, {[styles.active]: active})} style={{ backgroundColor: place.color }}>
      </div>
    </div>
  )
}

export default PlaceMarker
